import { ResourceResponse } from "@/api/resource";
import { ActivityCouponResult } from "@/types/coupon-wall";
import { SupplyListResponse } from "@/api/supply";
import { TabListResponse } from "@/api/tab";
import {
  ResourceDataState,
  CouponDataState,
  SupplyDataState,
  TabbarDataState,
} from "@/context/PageStateContext";
import { EnhancedSupplyCard } from "@/types/supplyList";
import { SupplyType } from "@/types/supplyList";
import { formatPoiInfo } from "@/lib/supplyUtils/formatPoiInfo";
import { formatProductInfo } from "@/lib/supplyUtils/formatProductInfo";

export function transformResourceData(resource: ResourceResponse): ResourceDataState {
  return {
    headBanner: resource?.headBanner || null,
    floatButton: resource?.floatButton || null,
    showCaseInfo: resource?.showCaseInfo || null,
  };
}

/**
 * 转换红包墙数据
 */
export function transformCouponData(
  couponData: ActivityCouponResult,
  isNotLoggedIn?: boolean,
): CouponDataState {
  return {
    rawData: couponData,
    isNotLoggedIn,
    quickScreenCouponList: couponData?.quickScreenCouponList || [],
  };
}

export function transformSupplyData(supplyData: SupplyListResponse): SupplyDataState {
  const supplyList = (supplyData?.supplyCardList || []).map((item) => {
    if (item.supplyType === SupplyType.Wayne) {
      return {
        supplyType: SupplyType.Wayne,
        poiCard: formatPoiInfo(item.poiCard),
      } as EnhancedSupplyCard;
    } else {
      return {
        supplyType: SupplyType.GroupBuy,
        productCard: formatProductInfo(item.productCard, supplyData?.requestId || "", "0"),
      } as EnhancedSupplyCard;
    }
  });

  return {
    list: supplyList,
    totalCount: supplyList.length,
    hasMore: !supplyData?.isLastPage,
    requestId: supplyData?.requestId || null,
  };
}

/**
 * 🆕 转换Tabbar数据（金刚区Tab列表）
 */
export function transformTabbarData(searchRule: TabListResponse): TabbarDataState {
  return {
    tabList: searchRule?.tabList || [],
  };
}
